import { render, staticRenderFns } from "./FiltersTags.vue?vue&type=template&id=9884891a&scoped=true&"
import script from "./FiltersTags.vue?vue&type=script&lang=js&"
export * from "./FiltersTags.vue?vue&type=script&lang=js&"
import style0 from "./FiltersTags.vue?vue&type=style&index=0&id=9884891a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9884891a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
